// #region imports

// --- HS Code
import { EventTypes } from './event-types';

// #endregion

export interface OidcClientNotification<T> {
  type: EventTypes;
  value?: T;
}
